import { GlassSortCode } from "../constants";

export const isClearGlassType = (glassType: string) =>
    glassType === GlassSortCode;

export const is1_4GlassThickness = (glassThickness: string) =>
    glassThickness === "1-4";
